"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfilterBedAction;
(function (SfilterBedAction) {
    SfilterBedAction.ON_TOGGLE_BED_SECTION = 'ON_TOGGLE_BED_SECTION';
    SfilterBedAction.TOGGLE_BED_SECTION = 'TOGGLE_BED_SECTION';
    SfilterBedAction.SELECT_BED_OPTION = 'SELECT_BED_OPTION';
    SfilterBedAction.ON_SELECT_BED_OPTION = 'ON_SELECT_BED_OPTION';
    SfilterBedAction.toggleBedSection = typesafe_actions_1.createAction(SfilterBedAction.TOGGLE_BED_SECTION, function (resolve) { return function (state) { return resolve(state); }; });
    SfilterBedAction.onToggleBedSection = typesafe_actions_1.createAction(SfilterBedAction.ON_TOGGLE_BED_SECTION, function (resolve) { return function () { return resolve(); }; });
    SfilterBedAction.onSelectBedOption = typesafe_actions_1.createAction(SfilterBedAction.ON_SELECT_BED_OPTION, function (resolve) { return function (bed) { return resolve(bed); }; });
    SfilterBedAction.selectBedOption = typesafe_actions_1.createAction(SfilterBedAction.SELECT_BED_OPTION, function (resolve) { return function (bed) { return resolve(bed); }; });
})(SfilterBedAction || (SfilterBedAction = {}));
exports.default = SfilterBedAction;
